/* Collection price filter — input hardening (all collections):
   1) only digits may be entered (blocks letters, e/E, +, -, ., commas, paste of non-digits)
   2) the minimum can never exceed the maximum (and vice-versa) */
(function () {
  function toInt(el) {
    if (!el || el.value === '' || el.value == null) return null;
    var n = parseInt(String(el.value).replace(/\D/g, ''), 10);
    return isNaN(n) ? null : n;
  }

  // Cap a field to its own min/max attribute ceiling/floor (e.g. the most expensive product).
  function capToAttrs(el) {
    if (!el) return;
    var v = toInt(el);
    if (v === null) return;
    var hi = el.getAttribute('max');
    var lo = el.getAttribute('min');
    if (hi !== null && hi !== '' && v > parseInt(hi, 10)) el.value = parseInt(hi, 10);
    if (lo !== null && lo !== '' && v < parseInt(lo, 10)) el.value = parseInt(lo, 10);
  }

  // Keep min <= max. `editing` is the field currently being edited (so when both fields
  // are in play, we adjust the one the user is actually touching — not the other one).
  function clamp(min, max, editing) {
    capToAttrs(min);
    capToAttrs(max);
    var vMin = toInt(min);
    var vMax = toInt(max);
    if (vMin === null || vMax === null || vMin <= vMax) return;
    var ed = editing || document.activeElement;
    if (ed === max) {
      max.value = vMin; // editing the max field -> it can't drop below the min
    } else {
      min.value = vMax; // editing the min field (or none) -> it can't exceed the max
    }
  }

  function harden(el, min, max) {
    if (!el || el.__priceWired) return;
    el.__priceWired = true;

    // Block any single printable character that isn't a digit (covers letters, e, +, -, ., ,)
    el.addEventListener('keydown', function (e) {
      if (e.ctrlKey || e.metaKey || e.altKey) return;      // allow shortcuts (copy/paste/select)
      if (e.key && e.key.length === 1 && !/[0-9]/.test(e.key)) e.preventDefault();
    });

    // Strip non-digits from a paste
    el.addEventListener('paste', function (e) {
      var data = (e.clipboardData || window.clipboardData);
      if (!data) return;
      var text = data.getData('text');
      if (/\D/.test(text)) {
        e.preventDefault();
        var clean = text.replace(/\D/g, '');
        if (clean) {
          try { document.execCommand('insertText', false, clean); }
          catch (err) { el.value = (el.value || '') + clean; }
        }
      }
    });

    // Clamp on blur / Enter — the field that fired is the one being committed.
    el.addEventListener('change', function () { clamp(min, max, el); });

    // The theme's filter auto-submits on `input` (debounced 500ms). Clamp on a shorter
    // debounce so the value is corrected BEFORE that submit fires — and so typing isn't
    // corrupted mid-entry (we wait for a brief pause). We pass the *currently focused*
    // field so the field the user is actually editing is the one that gets adjusted.
    // Programmatic value changes here don't fire `input`, so they don't reset the theme's timer.
    var ct;
    el.addEventListener('input', function () {
      clearTimeout(ct);
      ct = setTimeout(function () { clamp(min, max, document.activeElement); }, 300);
    });
  }

  function init() {
    var holders = document.querySelectorAll('.filter__price, [data-range-holder]');
    holders.forEach(function (holder) {
      var min = holder.querySelector('[data-field-price-min]');
      var max = holder.querySelector('[data-field-price-max]');
      harden(min, min, max);
      harden(max, min, max);
      // Normalize any pre-existing inverted / out-of-range values on load (and after re-render).
      clamp(min, max, null);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // The filter sidebar can be re-rendered after an AJAX filter update — re-wire then (debounced).
  if (window.MutationObserver) {
    var t;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(init, 200);
    }).observe(document.body, { childList: true, subtree: true });
  }
})();
